import React from "react";
import "./DonationSuccess.css";

const DonationSuccess = () => {
  return (
    <div className="donation-success-container">
      <h1>Thank You for Your Donation!</h1>
      <p>Your generous support helps Bonobo Hope continue its mission.</p>
      <p>A confirmation email has been sent to the address you provided.</p>
      <a href="/">Back to Home</a>
    </div>
  );
};

export default DonationSuccess;
